import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';
import LinkButton from 'src/app/components/Elements/Button/LinkButton';

export const ButtonSection = styled.div`
  margin-top: ${props => props.theme.space.none} !important;
`;

export const SelectFamilyButton = styled(Button)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &&&[data-checked='true'] {
    outline-color: ${({ theme }) => theme.colors.capsuleGreen60};
    border-color: ${({ theme }) => theme.colors.capsuleGreen60};
    background-color: ${({ theme }) => theme.colors.capsuleGreen60};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
  }
`;

export const FamilyButton = styled(LinkButton)`
  margin-top: ${props => props.theme.space['0.5']} !important;
  margin-bottom: ${props => props.theme.space['0.5']} !important;
`;
